'use client'

import { Suspense } from 'react'
import { UtmTrackerClient } from './utm-tracker-client'

export function UtmTracker() {
  return (
    <Suspense fallback={null}>
      <UtmTrackerClient />
    </Suspense>
  )
}

export default UtmTracker
